import { coaches } from './coaches'

export type Testimonial = {
  headline?: string
  /** Párrafos separados por una línea en blanco (\n\n). */
  quote: string
  author: string
  role: string
  avatar?: string
}

export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I used to spend too much time figuring out what to teach at each chess club meeting. Having ready-to-teach session plans gives me a clear structure to follow, so I don’t have to build every lesson from scratch.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      'I knew how to play chess, but teaching a group of kids was a different challenge. Having the lesson steps, activities and timings laid out would make it much easier to organise a session and know what comes next.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      'I wanted my sessions to feel less like a classroom lesson and more like an active chess club. Having puzzles, activities and game-based exercises together gives me more ways to keep students involved.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Our club meetings are short, so I need to make the most of the time available. Having a session plan with different duration options makes it easier to adapt the lesson to our schedule.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'Instead of choosing unrelated chess topics every week, I wanted a clearer path from basic concepts to tactics, checkmates, endgames and game play. Having the sessions organised around those themes gives me a useful framework.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      'The mix of puzzles, practical activities and games gave me more options for getting students involved during our chess club sessions.',
    author: coaches[5].name,
    role: coaches[5].role,
    avatar: coaches[5].avatar,
  },
]
